import React, { useCallback } from "react";
import { ButtonCustom } from "../../Common/ButtonCustom/ButtonCustom";
import { CheckOutlined } from "@ant-design/icons";

const cardData = [
  {
    title: "White Label Wallet",
    description: [
      "Multi-currency wallets",
      "Fiat & Crypto",
      "KYC/AML",
      "Admin console",
    ],
    number: "01",
  },
  {
    title: "Hybrid Visa Cards",
    description: [
      "Virtual/physical",
      "Reseller model",
      "Global issuance,",
      "Usage revenue",
    ],
    number: "02",
  },
  {
    title: "Fiat-to-Fiat Settlement",
    description: ["IBAN-based swaps", "Multi-currency", "Global freelancers"],
    number: "03",
  },
  {
    title: "STO & Tokenization Hub (Optional)",
    description: [
      "Legal rails",
      "Custody",
      "Compliance",
      "For real estate",
      "Equity",
    ],
    number: "04",
  },
  {
    title: "OTC Desk Integration (Optional)",
    description: ["Deep liquidity", "Confidential large volumes", "API"],
    number: "05",
  },
   {
    title: "Triskel Licences",
    description: [
      "Triskel Holding Dubai",
      "Triskel Crypto Fiat License Czech Republic",
      "Triskel Technology Panama",
      "Triskel Commercial Wyoming",
      "Triskel DAO Fund Marshall Islands",
      "Triskel Proprietary Broker SVG",
      "Triskel MSB Canada",
    ],
    number: "06",
  },
];

const HorizontalScroll = () => {
  return (
    <div className="scroll-wrapper">
      <div className="scroll-track ">
        <div className="scroll ">
          <p>Neobanks</p>
          <p>Crypto Exchanges</p>
          <p>Payment Platforms</p>
          <p>Family Offices</p>
          <p>Web3 Startups</p>
          <br />
        </div>
        {/* Duplicate items for seamless looping */}
        <div className="scroll">
          <p>Neobanks</p>
          <p>Crypto Exchanges</p>
          <p>Payment Platforms</p>
          <p>Family Offices</p>
          <p>Web3 Startups</p>
          <br />
        </div>
        <div className="scroll">
          <p>Neobanks</p>
          <p>Crypto Exchanges</p>
          <p>Payment Platforms</p>
          <p>Family Offices</p>
          <p>Web3 Startups</p>
            <br />
        </div>
      </div>
    </div>
  );
};

const B2B = () => {
  const handleScrollToForm = useCallback((event) => {
    event.preventDefault();
    const targetElement = document.getElementById("formSection");
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <>
   
      <div className="container">
        <div className="b2bHero">
          <div className="b2bHero_left">
            <h1>Launch Your Own Crypto-Fiat Super App</h1>
            <p>
              White Label & Reseller Program for Hybrid Financial Infrastructure
            </p>

            <ButtonCustom
              greenborder
              label="Become a Partner"
              onClick={handleScrollToForm}
              btnBorder={true}
            />
          </div>
          <div className="b2bHero_right">
            <div className="placeholder-img">
              <video src="/b2b-1.webm" autoPlay playsInline loop muted/>
            </div>
          </div>
        </div>
      </div>
      

      <div className="twoCol light-bg">
        <div className="container">
          <div className="container_left triskel-wallet">
            <h2>Triskel Wallet</h2>
            <p>
              A proven  B2C hybrid finance app, now powers institutional growth
              through Our B2B Partner Program.
              <br />
              <br /> Designed for fintech startups,
              banks, OTC decks, and Web3 innovators. It lets you deploy fully
              branded financial services - with our tech running silently
            </p>
          </div>
          <div className="container_right">
            <div className="placeholder-img">
              <video src="/b2b-2.webm" autoPlay playsInline loop muted/>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="b2bWhatWeOffer">
          <h2>What We Offer - Key Modules</h2>
          <div className="b2bWhatWeOffer_cards">
            {cardData.map((card, index) => (
              <div className="cardsData" key={index}>
                <h4>{card.title}</h4>
                <ul>
                  {card.description.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
                <span>{card.number}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="twoCol border-top">
        <div className="container">
          <div className="container_left ">
            <h2>Your Brand. Our Backbone.</h2>
            <ul className="first-ul-list">
              <li>You own the brand, client experience & growth</li>
              <li>We handle backend tech, compliance & finance</li>
              <li>24/7 infrastructure with world-class support</li>
            </ul>
          </div>
          <div className="container_right">
            <div className="placeholder-img">
              <video src="/b2b-3.webm" autoPlay playsInline loop muted/>
            </div>
          </div>
        </div>
      </div>

         <div id="formSection " className="twoCol">
        <div className="container  reverse-mobile">
            <div className="grow container_right second-backbone-section">
             <img src="/triskel-logo-b2b-section.png" alt="" />

           </div>
          <div className="container_left second-backbone-section">
            <h2>Why Triskel?</h2>
            <ul className="check-list">
              <li>
                <CheckOutlined />
                Proven product live in 70+ countries
              </li>
              <li>
                <CheckOutlined />
                Regulated & compliant infrastructure
              </li>
              <li>
                <CheckOutlined />
                Fully customizable UI modules
              </li>
              <li>
                <CheckOutlined />
                Seamless B2B onboarding & integration
              </li>
              <li>
                <CheckOutlined />
                Real-time settlement infrastructure
              </li>
            </ul>
          </div>
        </div>

          {/* <form action="">
              <div className="group">
                <label htmlFor="name">Name</label>
                <input type="text" id="name" />
              </div>
              <div className="group">
                <label htmlFor="company">Company</label>
                <input type="text" id="company" />
              </div>
              <div className="group">
                <label htmlFor="email">Email</label>
                <input type="email" id="email" />
              </div>
              <div className="group">
                <label htmlFor="useCase">Use Case</label>
                <input type="text" id="useCase" />
              </div>

              <ButtonCustom
                greenborder
                label="Apply for Access"
                //   onClick={handleClick}
                btnBorder={true}
              />
            </form> */}
          {/* </div> */}
        

        {/* cta button */}
        <div className="cta-btn-b2b ">
         <a href="https://docs.google.com/forms/d/e/1FAIpQLScFsk9dNFA2W8kJLjY2T6xXvWsAaUri-SpRg81un7gwBeSSdw/viewform " target="_blank">
          <button className="flex items-center gap-2 bg-lime-400 text-black font-medium py-2 px-4 rounded-full hover:bg-lime-300 transition">
            <span>Apply Now</span>
          </button>
          </a>
        </div>
      </div>

      <div className="twoCol light-bg ticker">
        <div className="container">
          <div className="container_left">
            <h2> Ideal For</h2>
          </div>
          <div className="grow container_right">
            <div className="ideal_row">
              <h3>Ideal For:</h3>
              <HorizontalScroll />
            </div>
          </div>
        </div>
      </div>

   
    </>
  );
};

export default B2B;
